export interface State {
  newFilter: string;
}

export const initialState: State = {
  newFilter: null,
};
